import { SetStateAction } from "react";
import { ModalWithButtons } from "./modal";
import { BlackButton, GreyButton } from "../button";
import { useTranslation } from "react-i18next";
import { NeutralColor } from "node-library/dist/colors";

interface Props {
	open: boolean;
	setOpen: React.Dispatch<SetStateAction<boolean>>;
	proceedAction: () => void;
}

export default function DeleteSpecificationConfirmModal(props: Props) {
	const { t: translation } = useTranslation();

	const modal: React.ReactNode = (
		<ModalWithButtons
			headerText={""}
			open={props.open}
			setOpen={props.setOpen}
			buttons={[
				<GreyButton
					key="discard-order-cancel-button"
					id="discard-order-cancel-button"
					children={translation("Cancel")}
					onClick={() => {
						props.setOpen(false);
					}}
				></GreyButton>,
				<BlackButton
					key="discard-order-proceed-button"
					id="discard-order-proceed-button"
					children={translation("Delete")}
					onClick={() => {
						setTimeout(() => props.proceedAction(), 1);
						props.setOpen(false);
					}}
				></BlackButton>,
			]}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					gap: "5px",
					alignItems: "center",
					textAlign: "center",
					marginTop: "-10px",
				}}
			>
				<div className="modal-body-icon discard-order-icon"></div>

				<div className="typography-body-02 typography-bold">
					{translation("DeleteFile?")}
				</div>
				<div
					className="typography-caption"
					style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
				>
					{translation("DeleteFileConfirmMessage")}
				</div>
				<div
					className="typography-caption"
					style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
				>
					{translation("CannotUndoAction")}
				</div>
			</div>
		</ModalWithButtons>
	);

	return modal;
}
